import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig, isAxiosError } from 'axios';
import { baseURL } from '~/utils/constants/env';
import { StorageEnum } from '~/utils/enum';
import { TIME_OUT } from '~/utils/constants/common';
import { getTimezone } from '~/utils/helper';
import { HTTP_RESPONSE } from '~/utils/constants/http-response';
import { adminRouteAbsolute } from '~/utils/constants/route';

const axiosClient = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: TIME_OUT,
});

// Add a request interceptor
axiosClient.interceptors.request.use(
  function (config: InternalAxiosRequestConfig) {
    // Do something before request is sent
    const token = localStorage.getItem(StorageEnum.ACCESS_TOKEN);
    const companyId = localStorage.getItem(StorageEnum.COMPANY_ID);

    config.headers.Authorization = token ? `Bearer ${token}` : '';
    config.headers['Bor-Timezone'] = getTimezone();
    config.headers['Bor-Company-Id'] = companyId;

    return config;
  },

  function (error: AxiosError | Error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  function (response: AxiosResponse) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },

  function (error: AxiosError | Error) {
    // Do something with response error
    if (isAxiosError(error)) {
      // Handle Unauthorize case
      if (error?.response?.status === HTTP_RESPONSE.COMMON.UNAUTHORIZED.code) {
        localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
        localStorage.removeItem(StorageEnum.REFRESH_TOKEN);

        setTimeout(() => {
          window.location.href = adminRouteAbsolute.login;
        }, 3000);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
